<template>
  <section class="who p-relative">
    <div class="divider">
      <svgDivider fillColor="#816998"/>
    </div>
    <div class="container grid-xl p-relative">
      <div class="columns">
        <div class="column col-lg-12 col-xl-5 a_col_1">
          <h1 class="who__heading">
            <span>Lorem ipsum</span>
            <span>dolor sit</span>
            <span>amet.</span>
          </h1>
          <div class="who__img_cnt">
            <img :src="require('../assets/images/android.png')" alt="Who we are image" class="border_r img">
          </div>
          <p>
            Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur
          </p>
        </div>
        <div class="column col-lg-12 col-xl-7 a_col_2">
          <h2 class="about__sub_title mt-0">Duis aute irure dolor in reprehenderit</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          </p>
          <Technologies/>
        </div>
      </div>
      <topButton :backColor="true"/>
    </div>
  </section>
</template>

<script>
import topButton from './topButton';
import Technologies from './Technologies';
import svgDivider from './svg_icons/svgDivider';
export default {
  name: 'FirstSection',
  components: {
    topButton,
    svgDivider,
    Technologies
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.who{
  &__heading{
    font-size: 3rem;
    text-transform: uppercase;
    line-height: 0.9;
    margin-top: 0;
    margin-bottom: 40px;
    color: rgba($gray-300, 0.2);
    >span{
      display: block;
      line-height: 0.9;
      &:last-child{
        color: $pink;
      }
    }
  }
  &__img_cnt{
    position: relative;
    height: 0;
    padding-bottom: 91.40625%;
    display: block;
    overflow: hidden;
    // background-color: lighten($dirty-vel, 15);
    border-radius: 4px;
    margin-bottom: calc(40px - 1em);
    .img{
      position: absolute;
    }
  }
  &__sub_title{
    margin-top: 40px;
  }
  p{
    text-align: justify;
    font-weight: 500;
  }
  .g_top_cnt{
    display: flex;
    align-items: center;
    padding-bottom: 8px;
  }
  .go_top_btn{
    position: absolute;
    right: 1rem;
    bottom: -75px;
  }
}
.technologies{
  color: rgba($gray-300, 0.3);
}
@media screen and (min-width: 961px){
  .a_col_1{
    padding-right: 1rem;
  }
  .a_col_2{
    padding-left: 1rem;
  }
}
</style>
